import { render } from "./SVGPlusButton.vue?vue&type=template&id=2f9719b4"
import script from "./SVGPlusButton.vue?vue&type=script&lang=js"
export * from "./SVGPlusButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__